module.exports = __webpack_public_path__ + "5f2518ff7b4a5c13c01885877c963625.png";